export enum StepEnum {
  WELCOME,
  LANDLORD_INFORMATION,
  HOUSE_INFO,
  INFO_ABOUT_TENANT,
  RENT_CONTRACT,
  CREATE_PASSWORD
}
